import wwwUrlEnv from '../helpers/www-url-env';

const DefaultSkipParameters = ['cchannel', 'ccontent', 'clicksessionid'];
export default {
    submitInterstitialUrl(postData) {
        const url = `${wwwUrlEnv.getWWWURL()}/interstitial/mylt`;
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = url;
        form.target = '_blank';

        Object.keys(postData).forEach((key) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            if (input.name && input.name.toLowerCase() === 'partnerurl') {
                input.value = this.getUrl(postData[key]);
            } else {
                input.value = postData[key];
            }
            form.appendChild(input);
        });
        document.body.appendChild(form);
        form.submit();
    },
    getUrl(url) {
        let newUrl = url;
        DefaultSkipParameters.forEach((item) => {
            const tempUrl = this.removeURLParameter(newUrl, item);
            newUrl = tempUrl;
        });
        return newUrl;
    },
    removeURLParameter(url, parameter) {
        let newUrl = url;
        const urlparts = newUrl.split('?');
        if (urlparts.length >= 2) {
            const prefix = encodeURIComponent(parameter).concat('=');
            const pars = urlparts[1].split(/[&;]/g);
            for (let i = pars.length; i-- > 0;) {
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }
            newUrl = `${urlparts[0]}?${pars.join('&')}`;
            return newUrl;
        }
        return newUrl;
    },
};
